import Big from "big.js";

type FormatAmountOptions = {
  decimals?: number;
  thousandSeparator?: string;
  decimalSeparator?: string;
  trimTrailingZeros?: boolean;
};

const DEFAULTS: Required<FormatAmountOptions> = {
  decimals: 2,
  thousandSeparator: " ",
  decimalSeparator: ",",
  trimTrailingZeros: false,
};

const normalizeNumericString = (value: string) => {
  const v = value.trim();
  if (!v) return "0";
  // API часто отдаёт "+123.45"
  return v.startsWith("+") ? v.slice(1) : v;
};

const addThousands = (intPart: string, sep: string) => {
  const sign = intPart.startsWith("-") ? "-" : "";
  const digits = sign ? intPart.slice(1) : intPart;
  const grouped = digits.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
  return sign + grouped;
};

export function formatAmount(
  value: string | number | Big | null | undefined,
  options?: FormatAmountOptions,
) {
  const opts = { ...DEFAULTS, ...(options || {}) };

  try {
    const big =
      value instanceof Big
        ? value
        : new Big(
            typeof value === "string"
              ? normalizeNumericString(value)
              : String(value ?? "0"),
          );

    const fixed = big.round(opts.decimals, Big.roundHalfUp).toFixed(opts.decimals);
    const [intPart, fracPart = ""] = fixed.split(".");

    const intWithSep = addThousands(intPart, opts.thousandSeparator);
    if (opts.decimals === 0) return intWithSep;

    let frac = fracPart;
    if (opts.trimTrailingZeros) {
      frac = frac.replace(/0+$/, "");
    }

    if (!frac) return intWithSep;
    return `${intWithSep}${opts.decimalSeparator}${frac}`;
  } catch {
    return String(value ?? "");
  }
}

